import { callSafe } from '../utils/functions';

export type DevicePixelRatioWatchCallback = (devicePixelRatio: number) => void;

interface DevicePixelRatioState {
	current: number;
	mediaQuery: MediaQueryList;
	watchers: DevicePixelRatioWatchCallback[];
}

let state: DevicePixelRatioState | null = null;

function ensureInitialized(): DevicePixelRatioState {
	if (state) {
		return state;
	}

	const initialState: DevicePixelRatioState = {
		current: window.devicePixelRatio,
		mediaQuery: window.matchMedia(`(resolution: ${window.devicePixelRatio}dppx)`),
		watchers: [],
	};

	function onChange(): void {
		const next = window.devicePixelRatio;
		initialState.current = next;
		initialState.mediaQuery.removeEventListener(
			'change',
			onChange,
		);
		initialState.mediaQuery = window.matchMedia(`(resolution: ${next}dppx)`);
		initialState.mediaQuery.addEventListener(
			'change',
			onChange,
		);

		for (const watcher of initialState.watchers) {
			callSafe(() => watcher(next));
		}
	}

	initialState.mediaQuery.addEventListener(
		'change',
		onChange,
	);
	state = initialState;
	return state;
}

export function getDevicePixelRatio(): number {
	return ensureInitialized().current;
}

export function watch(callback: DevicePixelRatioWatchCallback): () => void {
	const watcherState = ensureInitialized();
	watcherState.watchers.push(callback);

	return () => {
		const index = watcherState.watchers.indexOf(callback);

		if (index > -1) {
			watcherState.watchers.splice(
				index,
				1,
			);
		}
	};
}
